var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('router-link',{staticClass:"editorial-card",attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.data.display_image_url}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("truncate")(_vm.data.title,25)))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d1ee484","hasScoped":true,"transformToRequire":{"svg-component":"src","video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--1-1!./app/src/components/EditorialCard.vue
// module id = null
// module chunks = 